import { getMethod, postMethod, putMethod } from './api-service';

export const generatePresignedUrlCloudinary = async (data) => {
    try {
        const response = await postMethod('/file-upload/gen-pre-url-cloudinary', data);
        return response;
    } catch (error) {
        console.log("Error in generating presigned URL: ", error);
    }
}

export const generatePresignedUrlDigitalOcean = async (data) => {
    try {
        const response = await postMethod('/file-upload/gen-pre-url-do', data);
        return response;
    } catch (error) {
        console.log("Error in generating presigned URL: ", error);
    }
}

export const savePricingDetails = async (productId, data, params = {}) => {
    try {
        // Convert params object to query string
        const queryString = new URLSearchParams(params).toString();

        const url = `/products/${productId}/pricing${queryString ? `?${queryString}` : ""}`;

        const response = await putMethod(url, data);

        return response;
    } catch (error) {
        console.error('Error saving pricing details:', error);
        return { success: false, message: error.message };
    }
};